import { LensIcon } from '../assets/svgImages';
import { SearchProps } from '../interface/interface';

export function Search(props: Readonly<SearchProps>) {
  return (
    <div className="flex">
      <div className="relative flex items-center">
        <input
          type="text"
          name="search"
          placeholder="Search and press enter"
          value={props.value}
          onChange={(e) => props.changeHandler(e.target.value)}
          onKeyDown={(e) =>
            e.key === 'Enter' ? props.submitSearch((prev) => prev + 1) : null
          }
          className="block rounded border-0 py-1.5 w-72 text-gray-900 
          shadow-none placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring-transparent"
        />
        <LensIcon className="absolute right-2 w-4 top-1/2 transform -translate-y-1/2" />
      </div>
      {/* <button
        type="button"
        onClick={() => props.submitSearch((prev) => prev + 1)}
        className="ml-2 block rounded-md bg-secondary-cornflowerblue-600 px-10 py-2 text-center text-sm font-semibold text-white"
      >
        Search
      </button> */}
    </div>
  );
}
